// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordValidity.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import constants from 'logic/data/Izenda.SecurityPoliciesConstant';
import EventsUtils from 'EventUtils';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import action from 'modules/Settings/SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetailAction';
import Validator from 'share/components/hoc/Izenda.Validator';
const ValidatableInput = Validator()(Input);
const notifyChange = EventsUtils.notifyChange;
const minField = 'minNumberOfPasswordAge';
const maxField = 'maxNumberOfPasswordAge';

const PasswordValidity = connect(action)(function(props: any) {
  const localization = props.localization;
  return (
    <GridLayout>
      <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
        <GridLayout.Col cols='12' className='u_noPaddingAll'>
          <span className='u_textBold u_marginLeft'>
            {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_VALIDITY')}
          </span>
        </GridLayout.Col>
      </GridLayout.Row>
      <PasswordAge {...props} />
    </GridLayout>
  );
});

const PasswordAge = connect(action)(function(props: any) {
  const localization = props.localization;
  const model = props.store.model;
  const validateField = [minField, maxField];
  const validations = function(isMinField) {
    return constants.numberLimitConstraints(
      isMinField,
      constants.PASSWORD_VALIDITY.MIN_PASSWORD_AGE,
      constants.PASSWORD_VALIDITY.MAX_PASSWORD_AGE,
      model[minField],
      model[maxField]
    );
  };
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='12' className='u_noPaddingAll'>
        <GridLayout.Col cols='4'>
          <label>
            <Input
              type='checkbox'
              className='u_marginLeft'
              checked={model.passwordAge}
              onChange={notifyChange(props.onChangeValueCheckbox.bind(props, 'passwordAge'), EventsUtils.CHECKBOX)}
            />
            <span className='u_marginLeft'>
              {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_AGE')}
            </span>
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='8'>
          <span>{localization.getText('COMMON_LABEL_FROM')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            disabled={!model.passwordAge}
            field={minField}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            value={model[minField]}
            onChange={notifyChange(model.updateValueByKey.bind(model, minField), EventsUtils.INPUT)}
            validations={validations(true)}
          />
          <span>{localization.getText('COMMON_LABEL_TO')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            disabled={!model.passwordAge}
            field={maxField}
            value={model[maxField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            onChange={notifyChange(model.updateValueByKey.bind(model, maxField), EventsUtils.INPUT)}
            validations={validations(false)}
          />
          <span>{localization.getText('COMMON_LABEL_DAYS')}</span>
        </GridLayout.Col>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

export default PasswordValidity;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SecurityPolicies/PasswordPolicies/Izenda.PasswordValidity.js